export function dropdownTransitionState(status: string): "open" | "closed" {
  switch (status) {
    case "initial":
    case "open":
      return "open";
    default:
      return "closed";
  }
}
